module.exports = __webpack_public_path__ + "img/wizard_wechat-train.28c59180.png";